import { FiMenu, FiX } from 'react-icons/fi';
import './header.css';
import flowlightLogo from '/assets/Flowlight_logo.jpeg';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

const Header = () => {
  const location = useLocation();
  const selectedCategory = new URLSearchParams(location.search).get('category');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const getCategoryTo = (category: string) => {
    if (selectedCategory === category) return '/';
    return `/?category=${encodeURIComponent(category)}`;
  };

  const toggleMobileMenu = () => {
    if (isMobileMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMobileMenuOpen(false);
        setIsClosing(false);
      }, 300);
    } else {
      setIsMobileMenuOpen(true);
    }
  };

  const closeMobileMenu = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsMobileMenuOpen(false);
      setIsClosing(false);
    }, 300);
  };

  return (
    <>
      <header>
        <img src={flowlightLogo} alt="Flow Light Logo" className='logo' />
        <nav>
          <Link to="/">Home</Link>
          <div className="home-subcategories">
            <Link to={getCategoryTo('Products')}><small className={selectedCategory === 'Products' ? 'active' : ''}>Products</small></Link>
            <Link to={getCategoryTo('Bands')}><small className={selectedCategory === 'Bands' ? 'active' : ''}>Bands</small></Link>
            <Link to={getCategoryTo('Fashion')}><small className={selectedCategory === 'Fashion' ? 'active' : ''}>Fashion</small></Link>
            <Link to={getCategoryTo('Brands')}><small className={selectedCategory === 'Brands' ? 'active' : ''}>Brands</small></Link>
            <Link to={getCategoryTo('Portraits')}><small className={selectedCategory === 'Portraits' ? 'active' : ''}>Portraits</small></Link>
            <Link to={getCategoryTo('Documentaries')}><small className={selectedCategory === 'Documentaries' ? 'active' : ''}>Documentaries</small></Link>
            <Link to={getCategoryTo('Reels')}><small className={selectedCategory === 'Reels' ? 'active' : ''}>Reels</small></Link>

          </div>
          <a href="/about-me">About Me</a>
          <a href="/contact">Contact</a>
        </nav>
        <FiMenu aria-hidden="true" className='hamburger-icon' onClick={toggleMobileMenu} />
      </header>

      {isMobileMenuOpen && (
        <div className={`mobile-menu-overlay ${isClosing ? 'closing' : ''}`}>
          <div className={`mobile-menu-content ${isClosing ? 'closing' : ''}`}>
            <FiX className="close-icon" onClick={closeMobileMenu} />
            <div className={`mobile-menu-items ${isClosing ? 'closing' : ''}`}>
              <Link to="/" onClick={closeMobileMenu}>Home</Link>
              <div className="mobile-subcategories">
                <Link to={getCategoryTo('Products')} onClick={closeMobileMenu}><small className={selectedCategory === 'Products' ? 'active' : ''}>Products</small></Link>
                <Link to={getCategoryTo('Bands')} onClick={closeMobileMenu}><small className={selectedCategory === 'Bands' ? 'active' : ''}>Bands</small></Link>
                <Link to={getCategoryTo('Fashion')} onClick={closeMobileMenu}><small className={selectedCategory === 'Fashion' ? 'active' : ''}>Fashion</small></Link>
                <Link to={getCategoryTo('Brands')} onClick={closeMobileMenu}><small className={selectedCategory === 'Brands' ? 'active' : ''}>Brands</small></Link>
                <Link to={getCategoryTo('Portraits')} onClick={closeMobileMenu}><small className={selectedCategory === 'Portraits' ? 'active' : ''}>Portraits</small></Link>
                <Link to={getCategoryTo('Documentaries')} onClick={closeMobileMenu}><small className={selectedCategory === 'Documentaries' ? 'active' : ''}>Documentaries</small></Link>
                <Link to={getCategoryTo('Reels')} onClick={closeMobileMenu}><small className={selectedCategory === 'Reels' ? 'active' : ''}>Reels</small></Link>
              </div>
              <a href="/about-me" onClick={closeMobileMenu}>About Me</a>
              <a href="/contact" onClick={closeMobileMenu}>Contact</a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
